import React from 'react';
import PropTypes from 'prop-types';

const Progress = props => (
  <div className="progress-wrapper">
    {props.showStatus ? <div className="progress-status">{props.size}%</div> : ''}

    <div className="progress-content">
      <div className="progress">
        <div className="progress-inner" style={{ width: `${props.size}%` }} />
      </div>

      {props.description ? (
        <a className="progress-description">
          {props.description}
          <i className="md-icon">arrow_forward</i>
        </a>
      ) : (
        ''
      )}
    </div>
  </div>
);

Progress.propTypes = {
  size: PropTypes.number.isRequired,
  showStatus: PropTypes.bool,
  description: PropTypes.string,
};

Progress.defaultProps = {
  showStatus: false,
  description: null,
};

export default Progress;



// WEBPACK FOOTER //
// ./src/Shared/UI/Progress/Progress.js